"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.35.09H1.76C.84.09.09.84.09 1.76v10.66h1V1.76c0-.37.3-.67.67-.67h1.97v4.08c0 .81.66 1.47 1.47 1.47h5.59c.81 0 1.47-.66 1.47-1.47V1.09h.67l1.97 1.97v11.18c0 .37-.3.67-.67.67h-1.28V8.3H3.04v6.61H1.76a.67.67 0 0 1-.67-.67v-.75h-1v.75c0 .92.75 1.67 1.67 1.67h12.48c.92 0 1.67-.75 1.67-1.67V2.65L13.35.09Zm-2.08 5.08c0 .26-.21.47-.47.47H5.21a.47.47 0 0 1-.47-.47V1.09h6.53v4.08ZM4.05 9.29h7.92v5.61H4.04V9.29h.01Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.942.33H2.648A2.319 2.319 0 0 0 .33 2.648V18.63h1.125V2.64c0-.652.533-1.192 1.193-1.192h3.15v6.315c0 1.11.907 2.017 2.017 2.017H16.2c1.11 0 2.018-.907 2.018-2.017V1.455h1.267l3.067 3.068V21.36c0 .653-.532 1.185-1.184 1.185H19.26V12.63H4.763v9.915H2.655a1.194 1.194 0 0 1-1.192-1.185v-1.117H.338v1.117a2.313 2.313 0 0 0 2.317 2.31h18.713a2.311 2.311 0 0 0 2.31-2.31V4.058L19.95.33h-.008Zm-2.857 7.433a.89.89 0 0 1-.893.892H7.808a.89.89 0 0 1-.893-.892V1.455h10.17v6.308Zm-11.205 6h12.248v8.79H5.88v-8.79Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.59.44H3.53C1.83.44.44 1.82.44 3.53v21.31h1.5V3.52c0-.87.71-1.59 1.59-1.59h4.2v8.42c0 1.48 1.21 2.69 2.69 2.69H21.6c1.48 0 2.69-1.21 2.69-2.69V1.94h1.69l4.09 4.09v22.45c0 .87-.71 1.58-1.58 1.58h-2.81V16.84H6.35v13.22H3.54c-.87 0-1.59-.71-1.59-1.58v-1.49H.45v1.49c0 1.7 1.38 3.08 3.09 3.08h24.95c1.7 0 3.08-1.38 3.08-3.08V5.41L26.6.44h-.01Zm-3.81 9.91c0 .66-.53 1.19-1.19 1.19H10.41c-.66 0-1.19-.53-1.19-1.19V1.94h13.56v8.41Zm-14.94 8h16.33v11.72H7.84V18.35Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M39.81.84H5.295a4.45 4.45 0 0 0-4.44 4.44v31.98H2.73V5.288a2.564 2.564 0 0 1 2.565-2.565h6.488v12.795a3.85 3.85 0 0 0 3.847 3.847h16.762a3.85 3.85 0 0 0 3.848-3.847V2.715h2.797l6.248 6.248v33.75a2.564 2.564 0 0 1-2.565 2.565h-4.402V25.455H9.69v19.823H5.288a2.564 2.564 0 0 1-2.566-2.565V40.47H.849v2.243a4.45 4.45 0 0 0 4.44 4.44h37.424a4.45 4.45 0 0 0 4.44-4.44V8.19L39.803.84h.008Zm-5.453 14.678a1.975 1.975 0 0 1-1.972 1.972H15.623a1.975 1.975 0 0 1-1.973-1.972V2.715h20.708v12.803ZM11.566 27.323h24.878V45.27H11.565V27.323Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M53.08 1.12H7.06c-3.26 0-5.92 2.66-5.92 5.92v42.64h2.5V7.05c0-1.89 1.53-3.42 3.42-3.42h8.65v17.06c0 2.83 2.3 5.13 5.13 5.13h22.35c2.83 0 5.13-2.3 5.13-5.13V3.62h3.73l8.33 8.33v45c0 1.89-1.53 3.42-3.42 3.42h-5.87V33.94H12.92v26.43H7.05c-1.89 0-3.42-1.53-3.42-3.42v-2.99h-2.5v2.99c0 3.26 2.66 5.92 5.92 5.92h49.9c3.26 0 5.92-2.66 5.92-5.92V10.92l-9.8-9.8h.01Zm-7.27 19.57c0 1.45-1.18 2.63-2.63 2.63H20.83c-1.45 0-2.63-1.18-2.63-2.63V3.62h27.61v17.07ZM15.42 36.43h33.17v23.93H15.42V36.43Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconSaveDisk = function IconSaveDisk(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Save Disk' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "SaveDisk"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconSaveDisk.sizes = [16, 24, 32, 48, 64];
IconSaveDisk.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconSaveDisk;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/system/SaveDisk.js
// module id = 2444
// module chunks = 0